import lang from "./resourse";

const cropRawDataZHTW = [
  {
    'name': '咖啡豆',
    'category': '果樹',
    'season': ['春'],
    'growthDays': '15+8',
  },
  {
    'name': '柳橙',
    'category': '果樹',
    'season': ['春'],
    'growthDays': '15+8',
  },
  {
    'name': '櫻桃',
    'category': '果樹',
    'season': ['春'],
    'growthDays': '15+8',
  },
  {
    'name': '酪梨',
    'category': '果樹',
    'season': ['春'],
    'hasVariant': true,
    'growthDays': '15+8',
  },
  {
    'name': '巨大酪梨',
    'category': '果樹',
    'season': ['春'],
    'hasVariant': true,
    'growthDays': '15+8',
  },
  {
    'name': '杏仁',
    'category': '果樹',
    'season': ['夏'],
    'growthDays': '15+8',
  },
  {
    'name': '可可豆',
    'category': '果樹',
    'season': ['夏'],
    'growthDays': '15+8',
  },
  {
    'name': '椰子',
    'category': '果樹',
    'season': ['夏'],
    'growthDays': '15+8',
  },
  {
    'name': '檸檬',
    'category': '果樹',
    'season': ['夏'],
    'growthDays': '15+8',
  },
  {
    'name': '香蕉',
    'category': '果樹',
    'season': ['夏'],
    'growthDays': '15+8',
  },
  {
    'name': '桃子',
    'category': '果樹',
    'season': ['夏'],
    'hasVariant': true,
    'growthDays': '15+8',
  },
  {
    'name': '黃金桃子',
    'category': '果樹',
    'season': ['夏'],
    'hasVariant': true,
    'growthDays': '15+8',
  },
  {
    'name': '芒果',
    'category': '果樹',
    'season': ['夏'],
    'growthDays': '15+8',
  },
  {
    'name': '橄欖',
    'category': '果樹',
    'season': ['秋'],
    'growthDays': '15+8',
  },
  {
    'name': '葡萄',
    'category': '果樹',
    'season': ['秋'],
    'growthDays': '15+8',
  },
  {
    'name': '蘋果',
    'category': '果樹',
    'season': ['秋'],
    'hasVariant': true,
    'growthDays': '15+8',
  },
  {
    'name': '黃金蘋果',
    'category': '果樹',
    'season': ['秋'],
    'hasVariant': true,
    'growthDays': '15+8',
  },
  {
    "name": "洋蔥",
    "category": "蔬菜",
    "season": [
      "春",
      "夏",
    ],
    "growthDays": "6",
  },
  {
    "name": "蕪菁",
    "category": "蔬菜",
    "season": [
      "春",
    ],
    "hasVariant": true,
    "growthDays": "4",
  },
  {
    "name": "巨大蕪菁",
    "category": "蔬菜",
    "season": [
      "春",
    ],
    "hasVariant": true,
  },
  {
    "name": "草莓",
    "category": "蔬菜",
    "season": [
      "春",
    ],
    "hasVariant": true,
    "growthDays": "8",
  },
  {
    "name": "黃金草莓",
    "category": "蔬菜",
    "season": [
      "春",
    ],
    "hasVariant": true,
  },
  {
    "name": "小黃瓜",
    "category": "蔬菜",
    "season": [
      "春",
    ],
    "growthDays": "7+4+4",
  },
  {
    "name": "大蒜",
    "category": "蔬菜",
    "season": [
      "春",
    ],
    "growthDays": "5+4+4",
  },
  {
    "name": "櫻桃蘿蔔",
    "category": "蔬菜",
    "season": [
      "春",
      "夏",
      "秋"
    ],
    "growthDays": "5",
  },

  {
    "name": "南瓜",
    "category": "蔬菜",
    "season": [
      "夏"
    ],
    "growthDays": "5",
  },
  {
    "name": "甜椒",
    "category": "蔬菜",
    "season": [
      "夏"
    ],
    "growthDays": "7+4+4",
  },
  {
    "name": "玉蜀黍",
    "category": "蔬菜",
    "season": [
      "夏"
    ],
    "hasVariant": true,
    "growthDays": "8+4+4",
  },
  {
    "name": "彩色玉蜀黍",
    "category": "蔬菜",
    "season": [
      "夏"
    ],
    "hasVariant": true,
  },
  {
    "name": "櫛瓜",
    "category": "蔬菜",
    "season": [
      "夏"
    ],
    "growthDays": "8",
  },
  {
    "name": "鳳梨",
    "category": "蔬菜",
    "season": [
      "夏"
    ],
    "growthDays": "6",
  },
  {
    "name": "西瓜",
    "category": "蔬菜",
    "season": [
      "夏"
    ],
    "topPrice": true,
    "growthDays": "9",
  },
  {
    "name": "番茄",
    "category": "蔬菜",
    "season": [
      "夏",
      "秋",
    ],
    "hasVariant": true,
    "growthDays": "6+4+4",
  },
  {
    "name": "巨大番茄",
    "category": "蔬菜",
    "season": [
      "夏",
      "秋",
    ],
    "hasVariant": true,
  },
  {
    "name": "哈密瓜",
    "category": "蔬菜",
    "season": [
      "夏",
      "秋",
    ],
    "hasVariant": true,
    "growthDays": "7",
  },
  {
    "name": "珠寶哈密瓜",
    "category": "蔬菜",
    "season": [
      "夏",
      "秋",
    ],
    "hasVariant": true,
  },
  {
    "name": "茄子",
    "category": "蔬菜",
    "season": [
      "夏"
    ],
    "hasVariant": true,
    "growthDays": "7+4+4",
  },
  {
    "name": "圓球茄子",
    "category": "蔬菜",
    "season": [
      "夏"
    ],
    "hasVariant": true,
  },
  {
    "name": "青椒",
    "category": "蔬菜",
    "season": [
      "夏"
    ],
    "growthDays": "8+6+6",
  },

  {
    "name": "菠菜",
    "category": "蔬菜",
    "season": [
      "秋",
    ],
    "hasVariant": true,
    "growthDays": "4",
  },
  {
    "name": "愛心菠菜",
    "category": "蔬菜",
    "season": [
      "秋",
    ],
    "hasVariant": true,
  },
  {
    "name": "秋葵",
    "category": "蔬菜",
    "season": [
      "秋",
    ],
    "growthDays": "8+4+4",
  },
  {
    "name": "蕃薯",
    "category": "蔬菜",
    "season": [
      "秋",
    ],
    "topPrice": true,
    "hasVariant": true,
    "growthDays": "6+4+4",
  },
  {
    "name": "巨大蕃薯",
    "category": "蔬菜",
    "season": [
      "秋",
    ],
    "topPrice": true,
    "hasVariant": true,
  },
  {
    "name": "辣椒",
    "category": "蔬菜",
    "season": [
      "秋",
    ],
    "growthDays": "9",
  },
  {
    "name": "胡蘿蔔",
    "category": "蔬菜",
    "season": [
      "秋",
      "冬",
    ],
    "growthDays": "5",
  },
  {
    "name": "青江菜",
    "category": "蔬菜",
    "season": [
      "秋",
      "冬",
    ],
    "growthDays": "9",
  },
  {
    "name": "白菜",
    "category": "蔬菜",
    "season": [
      "秋",
      "冬"
    ],
    "hasVariant": true,
    "growthDays": "6",
  },
  {
    "name": "黃金白菜",
    "category": "蔬菜",
    "season": [
      "秋",
      "冬"
    ],
    "hasVariant": true,
  },

  {
    "name": "青蔥",
    "category": "蔬菜",
    "season": [
      "冬"
    ],
    "hasVariant": true,
    "topPrice": true,
    "growthDays": "4",
  },
  {
    "name": "巨大的青蔥",
    "category": "蔬菜",
    "season": [
      "冬"
    ],
    "hasVariant": true,
    "topPrice": true,
  },
  {
    "name": "牛蒡",
    "category": "蔬菜",
    "season": [
      "冬"
    ],
    "growthDays": "7",
  },
  {
    "name": "馬鈴薯",
    "category": "蔬菜",
    "season": [
      "冬",
      "春",
      "夏",
    ],
    "hasVariant": true,
    "growthDays": "6",
  },
  {
    "name": "星型馬鈴薯",
    "category": "蔬菜",
    "season": [
      "冬",
      "春",
      "夏",
    ],
    "hasVariant": true,
  },
  {
    "name": "高麗菜",
    "category": "蔬菜",
    "season": [
      "冬",
      "春",
    ],
    "growthDays": "7",
  },
  {
    "name": "綠花椰菜",
    "category": "蔬菜",
    "season": [
      "冬",
      "春",
    ],
    "topPrice": true,
    "growthDays": "6+3+3",
  },
  {
    "name": "白蘿蔔",
    "category": "蔬菜",
    "season": [
      "冬",
      "春",
    ],
    "hasVariant": true,
    "growthDays": "4",
  },
  {
    "name": "分岔白蘿蔔",
    "category": "蔬菜",
    "season": [
      "冬",
      "春",
    ],
    "hasVariant": true
  },

  {
    "name": "鬱金香",
    "category": "花卉",
    "season": [
      "春"
    ],
    "growthDays": "3",
  },
  {
    "name": "粉蝶花",
    "category": "花卉",
    "season": [
      "春"
    ],
    "growthDays": "4",
  },
  {
    "name": "三色堇",
    "category": "花卉",
    "season": [
      "春"
    ],
    "growthDays": "5",
  },
  {
    "name": "陸蓮花",
    "category": "花卉",
    "season": [
      "春"
    ],
    "growthDays": "6",
  },
  {
    "name": "黑色三色堇",
    "category": "花卉",
    "season": [
      "春"
    ],
    "growthDays": "6",
  },

  {
    "name": "扶桑花",
    "category": "花卉",
    "season": [
      "夏"
    ],
    "growthDays": "3",
  },
  {
    "name": "矮牽牛",
    "category": "花卉",
    "season": [
      "夏"
    ],
    "growthDays": "4",
  },
  {
    "name": "萬壽菊",
    "category": "花卉",
    "season": [
      "夏"
    ],
    "growthDays": "5",
  },
  {
    "name": "向日葵",
    "category": "花卉",
    "season": [
      "夏"
    ],
    "growthDays": "6",
  },
  {
    "name": "百合",
    "category": "花卉",
    "season": [
      "夏"
    ],
    "growthDays": "6",
  },

  {
    "name": "玫瑰",
    "category": "花卉",
    "season": [
      "秋"
    ],
    "growthDays": "3",
  },
  {
    "name": "乒乓菊",
    "category": "花卉",
    "season": [
      "秋"
    ],
    "growthDays": "4",
  },
  {
    "name": "鐵線蓮",
    "category": "花卉",
    "season": [
      "秋"
    ],
    "growthDays": "5",
  },
  {
    "name": "瑪格麗特",
    "category": "花卉",
    "season": [
      "秋"
    ],
    "growthDays": "6",
  },
  {
    "name": "黑薔薇",
    "category": "花卉",
    "season": [
      "秋"
    ],
    "growthDays": "6",
  },

  {
    "name": "富貴菊",
    "category": "花卉",
    "season": [
      "冬"
    ],
    "growthDays": "3",
  },
  {
    "name": "報春花",
    "category": "花卉",
    "season": [
      "冬"
    ],
    "growthDays": "4",
  },
  {
    "name": "秋海棠",
    "category": "花卉",
    "season": [
      "冬"
    ],
    "growthDays": "5",
  },
  {
    "name": "風鈴草",
    "category": "花卉",
    "season": [
      "冬"
    ],
    "growthDays": "6",
  },
  {
    "name": "聖誕玫瑰",
    "category": "花卉",
    "season": [
      "冬"
    ],
    "topPrice": true,
    "growthDays": "6",
  },

  {
    "name": "稻米",
    "category": "農作物",
    "season": [
      "春",
      "夏",
      "秋"
    ],
    "growthDays": "14",
  },
  {
    "name": "小麥",
    "category": "農作物",
    "season": [
      "春",
      "夏",
      "秋"
    ],
    "growthDays": "12",
  },
  {
    "name": "茶葉",
    "category": "農作物",
    "season": [
      "春",
      "夏",
      "秋"
    ],
    "growthDays": "12",
  },
  {
    "name": "豆子",
    "category": "農作物",
    "season": [
      "春",
      "夏",
      "秋"
    ],
    "growthDays": "12",
  },
  {
    "name": "乾草飼料",
    "category": "農作物",
    "season": [
      "春",
      "夏",
      "秋"
    ],
    "growthDays": "5×6",
  },
];

const cropRawData = cropRawDataZHTW.map(crop => {
  const translatedCrop = {
    key: crop.name,
    name: lang(crop.name),
    category: crop.category,
    season: crop.season,
    hasVariant: crop.hasVariant ?? false,
    topPrice: crop.topPrice ?? false,
    growthDays: crop.growthDays ?? '',
  }
  return translatedCrop;
})

export default cropRawData;